/* eslint-disable no-param-reassign */
import { World } from '$legacyecstatic';
import { Components } from 'editor/components';
import { addEvents, addEventsComponents } from 'editor/systems/addEvents';
import {
  manageCursor,
  manageCursorComponents,
} from 'editor/systems/manageCursor';
import {
  configureTool,
  configureToolComponents,
} from 'editor/systems/map/configureTool';
import {
  manageCamera,
  manageCameraComponents,
} from 'editor/systems/map/manageCamera';
import {
  manageCanvasSource,
  manageCanvasSourceComponents,
} from 'editor/systems/map/manageCanvasSource';
import {
  manageLayer,
  manageLayerComponents,
} from 'editor/systems/map/manageLayer';
import { manageMap, manageMapComponents } from 'editor/systems/map/manageMap';
import {
  manageMarker,
  manageMarkerComponents,
} from 'editor/systems/map/manageMarker';
import {
  manageOverlay,
  manageOverlayComponents,
} from 'editor/systems/map/manageOverlay';
import {
  manageRasterSource,
  manageRasterSourceComponents,
} from 'editor/systems/map/manageRasterSource';
import {
  prepareCanvas,
  prepareCanvasComponents,
} from 'editor/systems/map/prepareCanvas';
import {
  syncMarkerToMarkup,
  syncMarkerToMarkupComponents,
} from 'editor/systems/map/syncMarkerToMarkup';
import {
  moveBoxControlPoint,
  moveBoxControlPointComponents,
} from 'editor/systems/moveBoxControlPoint';
import { moveMarkup, moveMarkupComponents } from 'editor/systems/moveMarkup';
import {
  renderControlPoints2,
  renderControlPoints2Components,
} from 'editor/systems/renderControlPoints2';
import {
  renderMarkup2,
  renderMarkup2Components,
} from 'editor/systems/renderMarkup2';
import {
  renderTempRect,
  renderTempRectComponents,
} from 'editor/systems/renderTempRect';
import {
  transformCanvas,
  transformCanvasComponents,
} from 'editor/systems/transformCanvas';

export default function addMapSystems(world: World<Components>): void {
  world.addSystem(manageMapComponents, manageMap);

  world.addSystem(addEventsComponents, addEvents);

  world.addSystem(manageCursorComponents, manageCursor);

  world.addSystem(manageCameraComponents, manageCamera);

  world.addSystem(prepareCanvasComponents, prepareCanvas);

  world.addSystem(transformCanvasComponents, transformCanvas);

  world.addSystem(manageCanvasSourceComponents, manageCanvasSource);

  world.addSystem(manageRasterSourceComponents, manageRasterSource);

  world.addSystem(manageOverlayComponents, manageOverlay);

  world.addSystem(manageLayerComponents, manageLayer);

  world.addSystem(syncMarkerToMarkupComponents, syncMarkerToMarkup);

  world.addSystem(manageMarkerComponents, manageMarker);

  world.addSystem(renderTempRectComponents, renderTempRect);

  world.addSystem(renderMarkup2Components, renderMarkup2);

  world.addSystem(renderControlPoints2Components, renderControlPoints2);

  world.addSystem(configureToolComponents, configureTool);

  world.addSystem(moveMarkupComponents, moveMarkup);

  world.addSystem(moveBoxControlPointComponents, moveBoxControlPoint);
}
